export enum ChatsQueryKeys {
  Chats = "chats",
  ChatsPaginated = "chats-paginated",
  ChatMessages = "chat-messages",
  ChatMessagesPaginated = "chat-messages-paginated",
  ChatContacts = "chat-contacts",
}
